import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormEntityContext } from '../../config/context/forms'
import FieldWrapper from './FieldWrapper'
import { FormField } from '@/components/ui/form'
import { FieldProps } from './types'
import FileInput from '../../pages/TeamDashboard/subpages/TeamOverview/components/FileInput'
import { cn } from '@/lib/utils'

const FileField = ({
  name,
  customDescription,
  customLabel,
  customPlaceholder,
  onBlur,
  layout = 'inline',
  className,
  inputClassName,
}: FieldProps<number>) => {
  const { t } = useTranslation()
  const form = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  return (
    <div className={`mt-2 ${layout === 'inline-shrinkable' ? '' : 'w-full'}`}>
      <FormField
        control={form.control}
        name={name}
        render={() => {
          return (
            <FieldWrapper
              layout={layout}
              label={
                customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
              }
              description={
                customDescription ??
                t(`${i18nPrefix}.${entityType}.${name}.description`)
              }
            >
              <FileInput
                className={cn(className, '-mt-8')}
                customPlaceholder={customPlaceholder}
                inputClassName={inputClassName}
                name={name}
                onBlur={onBlur}
              />
            </FieldWrapper>
          )
        }}
      />
    </div>
  )
}

export default FileField
